var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86759 4.63008C3.34947 4.8046 3 5.29459 3 5.84649V9.34829C3 14.9048 6.37552 19.8913 11.5001 21.9052C11.8216 22.0316 12.1784 22.0316 12.4999 21.9052C17.6245 19.8913 21 14.9048 21 9.34829V5.84649C21 5.29459 20.6505 4.80461 20.1324 4.63008L12.6325 2.10372C12.2219 1.96543 11.7781 1.96543 11.3675 2.10372L3.86759 4.63008ZM7 10.7914C7 7.99327 9.75008 6.94859 12 9.1101C14.2499 6.94859 17 7.99327 17 10.7914C17 12.4663 14.9903 14.2378 13.5191 15.3102C12.8531 15.7956 12.5201 16.0384 12 16.0384C11.4799 16.0384 11.1469 15.7956 10.4809 15.3102C9.00971 14.2378 7 12.4663 7 10.7914Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalProtection);
export default __webpack_public_path__ + "static/media/medical-protection.292b7bbcc30d146eaaff8de555d74f66.svg";
export { ForwardRef as ReactComponent };